import { z } from 'zod';
import { SetupTypeSchema } from './decision.js';

export const ThesisStateSchema = z.enum([
  'DRAFT',
  'WATCHING',
  'READY',
  'OWNED_INTACT',
  'OWNED_UNDER_REVIEW',
  'BROKEN',
  'TARGET_REACHED',
  'CLOSED',
  'ARCHIVED',
]);

export type ThesisState = z.infer<typeof ThesisStateSchema>;

export const ThesisSchema = z.object({
  thesisId: z.string(),
  securityId: z.string().optional(),
  setupType: SetupTypeSchema,
  state: ThesisStateSchema,
  title: z.string(),
  summary: z.string(),
  falsifiers: z.array(z.string()).min(1),
  catalysts: z.array(z.string()).default([]),
  horizonMonths: z.number().int().positive(),
  sourceIds: z.array(z.string()).min(1),
  knownAt: z.string(),
  version: z.number().int().positive(),
  playerMapId: z.string().optional(),
  valuationRunIds: z.array(z.string()).default([]),
});

export type Thesis = z.infer<typeof ThesisSchema>;
